// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 474 ? "fe69a73d" : chunkId) + "." + {"474":"572452e7f029f544","2441":"dbae2688bdba4b36","9206":"ea5ec4e3bad4a9fa"}[chunkId] + ".js";
};